import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

const Header = ({
  organizationList,
  handleSelectedOrganization,
  handleLogout,
  selectedOrganization,
}) => {
  return (
    <header className="px-4 flex border border-darkBlue flex-row justify-between items-center bg-headerBlue text-headerWhite text-bgGray">
      <div className="flex flex-row w-full items-center justify-between p-2">
        <div className="pr-2">
          <img
            className="w-32 h-auto mt-2"
            src={`${process.env.PUBLIC_URL}/img/logo.png`}
            alt="Fastigo logotyp"
            style={{ filter: 'brightness(0) invert(1)' }}
          />
        </div>

        <div className="flex items-center h-18 gap-5">
          <div className="relative flex md:flex-row items-center flex-col">
            {selectedOrganization && organizationList ? (
              <div>
                <select
                  style={{ backgroundImage: 'none' }}
                  className="relative bg-white md:w-64 w-48 text-darkBlue p-1 h-8 sm:p-2 sm:h-16 text-sm text-center border-2 rounded-sm border-bgGray font-bold"
                  defaultValue={selectedOrganization.name}
                  onChange={(e) => handleSelectedOrganization(e.target.value)}
                >
                  {organizationList.map((organization) => {
                    return (
                      <option
                        className="text-darkBlue"
                        key={organization.id}
                        value={organization.name}
                      >
                        {organization.name} {organization.orgNr}
                      </option>
                    )
                  })}
                </select>
              </div>
            ) : (
              <select
                style={{ backgroundImage: 'none' }}
                className="relative bg-white md:w-64 w-48 text-darkBlue p-1 h-8 sm:p-2 sm:h-16 text-sm text-center border-2 rounded-sm border-bgGray font-bold"
                onChange={(e) => e.preventDefault()}
              >
                <option>Laddar...</option>
              </select>
            )}
            <button className="btn flex flex-col" onClick={async () => await handleLogout()}>
              <FontAwesomeIcon icon={faLock} size="lg" className="hidden md:block height-15"/>
              Logga ut
              <span className="no-underline ml-2" />
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  handleSelectedOrganization: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  organizationList: PropTypes.array,
  selectedOrganization: PropTypes.object,
}
export default Header
